var map = {
	"./AashiqueAhmedIqbal.png": 601,
	"./BusinessintheTimeofContagion.jpeg": 602,
	"./KarunaWielenga.png": 603,
	"./LakshmiSubramanian.png": 604,
	"./LouizaRodrigues.png": 605,
	"./MadMenofBombay.png": 606,
	"./MilanBalaban.png": 607,
	"./PowerPrivilegePosture.jpeg": 608,
	"./SaritaSundar.png": 609,
	"./Speaker1.png": 610,
	"./SusiePak.png": 611,
	"./TheGlobalBlueJeansTransformation.jpg": 612,
	"./TimberTradeTrajectory.jpeg": 613,
	"./TraceyPanek.png": 614,
	"./TypewriterTipTip.png": 615,
	"./WilliamMazzarella.png": 616,
	"./details-banner/BusinessInTheTimeOfContagion.png": 617,
	"./details-banner/MadMenOfBombay.png": 618,
	"./details-banner/PowerPrivilegeposture.png": 619,
	"./details-banner/TheGlobalBlueJeans.png": 620,
	"./details-banner/TimberTradeTrajectory.png": 621,
	"./details-banner/TypewriterTipTip.png": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 600;